<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M18.3346 9.83289V11.668C18.3346 14.8106 18.3346 16.3821 17.3583 17.3583C16.3821 18.3346 14.8107 18.3346 11.668 18.3346H8.33464C5.19195 18.3346 3.62059 18.3346 2.64428 17.3583C1.83234 16.5464 1.69564 15.3229 1.67263 13.1264H8.91272L7.02957 14.4959C6.75041 14.6989 6.68869 15.0898 6.89171 15.369C7.09474 15.6481 7.48562 15.7098 7.76478 15.5068L11.2023 13.0068C11.364 12.8892 11.4596 12.7013 11.4596 12.5014C11.4596 12.3014 11.364 12.1135 11.2023 11.9959L7.76478 9.49589C7.48562 9.29289 7.09474 9.35455 6.89171 9.63372C6.68869 9.91288 6.75041 10.3038 7.02957 10.5068L8.91272 11.8764H1.66798L1.66797 11.668L1.66799 5.79276C1.66799 5.05734 1.66799 4.68959 1.72579 4.38329C1.98019 3.03489 3.03491 1.98017 4.38331 1.72576C4.68961 1.66797 5.05734 1.66797 5.79278 1.66797C6.115 1.66797 6.27612 1.66797 6.43096 1.68245C7.09853 1.74488 7.73175 2.00717 8.24794 2.43506C8.36764 2.53431 8.48155 2.64824 8.70947 2.87609L9.16797 3.33464C9.8478 4.01445 10.1877 4.35436 10.5947 4.58083C10.8184 4.70523 11.0556 4.80347 11.3016 4.87362C11.7496 5.0013 12.2303 5.0013 13.1916 5.0013H13.5031C15.6967 5.0013 16.7936 5.0013 17.5065 5.64252C17.5721 5.7015 17.6345 5.76392 17.6935 5.82949C18.3346 6.54243 18.3346 7.63925 18.3346 9.83289Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ObjectionsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>